<!-- 
全て開くボタンを作成するモジュール
@props
  title 全て開くボタンに表示するタイトル
-->

<template>
  <div>
    <v-btn text color="white" @click="toggleState"
      ><v-icon>{{ buttonIcon }}</v-icon
      ><span class="button-title">{{ title }}</span></v-btn
    >
  </div>
</template>

<script>
export default {
  props: ["title"],
  computed: {
    /**
     * 開閉状態を表現するアイコンを指定する
     */
    buttonIcon() {
      return this.openFlag ? "mdi-chevron-down" : "mdi-chevron-right";
    },
  },
  data() {
    return {
      openFlag: false,
    };
  },
  methods: {
    /**
     * 開閉状態を変更する
     */
    toggleState() {
      this.openFlag = !this.openFlag;
      this.$emit("on-change-open-state", this.openFlag);
    },
  },
};
</script>

<style scoped>
.button-title {
  font-size: 0.75rem;
  font-weight: bold;
}
</style>
